/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PayoutDistribution } from './PayoutDistribution';
import {
    PayoutDistributionFromJSON,
    PayoutDistributionFromJSONTyped,
    PayoutDistributionToJSON,
    PayoutDistributionToJSONTyped,
} from './PayoutDistribution';
import type { PayoutTier } from './PayoutTier';
import {
    PayoutTierFromJSON,
    PayoutTierFromJSONTyped,
    PayoutTierToJSON,
    PayoutTierToJSONTyped,
} from './PayoutTier';

/**
 * 
 * @export
 * @interface UpdatePayoutTableBody
 */
export interface UpdatePayoutTableBody {
    /**
     * 
     * @type {string}
     * @memberof UpdatePayoutTableBody
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePayoutTableBody
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdatePayoutTableBody
     */
    minTeams?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdatePayoutTableBody
     */
    maxTeams?: number;
    /**
     * 
     * @type {Array<PayoutDistribution>}
     * @memberof UpdatePayoutTableBody
     */
    distribution?: Array<PayoutDistribution>;
    /**
     * 
     * @type {Array<PayoutTier>}
     * @memberof UpdatePayoutTableBody
     */
    tiers?: Array<PayoutTier>;
    /**
     * 
     * @type {boolean}
     * @memberof UpdatePayoutTableBody
     */
    isDefault?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdatePayoutTableBody
     */
    isActive?: boolean;
}

/**
 * Check if a given object implements the UpdatePayoutTableBody interface.
 */
export function instanceOfUpdatePayoutTableBody(value: object): value is UpdatePayoutTableBody {
    return true;
}

export function UpdatePayoutTableBodyFromJSON(json: any): UpdatePayoutTableBody {
    return UpdatePayoutTableBodyFromJSONTyped(json, false);
}

export function UpdatePayoutTableBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatePayoutTableBody {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'minTeams': json['minTeams'] == null ? undefined : json['minTeams'],
        'maxTeams': json['maxTeams'] == null ? undefined : json['maxTeams'],
        'distribution': json['distribution'] == null ? undefined : ((json['distribution'] as Array<any>).map(PayoutDistributionFromJSON)),
        'tiers': json['tiers'] == null ? undefined : ((json['tiers'] as Array<any>).map(PayoutTierFromJSON)),
        'isDefault': json['isDefault'] == null ? undefined : json['isDefault'],
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
    };
}

export function UpdatePayoutTableBodyToJSON(json: any): UpdatePayoutTableBody {
    return UpdatePayoutTableBodyToJSONTyped(json, false);
}

export function UpdatePayoutTableBodyToJSONTyped(value?: UpdatePayoutTableBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
        'minTeams': value['minTeams'],
        'maxTeams': value['maxTeams'],
        'distribution': value['distribution'] == null ? undefined : ((value['distribution'] as Array<any>).map(PayoutDistributionToJSON)),
        'tiers': value['tiers'] == null ? undefined : ((value['tiers'] as Array<any>).map(PayoutTierToJSON)),
        'isDefault': value['isDefault'],
        'isActive': value['isActive'],
    };
}

